import { Component, inject } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { WkTranslatePipe } from "@shared/utils";
import { WkDataTableSelectionService } from "@app/shared/components/data-table/item";
import { WkDataTableContextService } from "@components/data-table/data-table-context.service";

@Component({
    selector: "wk-data-table-actionbar",
    templateUrl: "./data-table-actionbar.component.html",
    styleUrls: ["./data-table-actionbar.component.scss", "../data-table-action.scss"],
    imports: [WkTranslatePipe, ReactiveFormsModule, JumpstartComponentsModule],
    host: {
        class: "wk-data-table__actionbar",
    },
})
export class WkDataTableActionbar<TItem> {
    private readonly dataTableSelectionService = inject<WkDataTableSelectionService<TItem>>(WkDataTableSelectionService);
    protected readonly dataTableContext = inject<WkDataTableContextService<TItem>>(WkDataTableContextService);

    protected readonly selections = this.dataTableSelectionService.selections;
    protected readonly areAllSelected = this.dataTableSelectionService.areAllSelected;
    protected readonly toggleSelectAll = this.dataTableSelectionService.toggleSelectAll.bind(this.dataTableSelectionService);
    protected readonly clearAll = this.dataTableSelectionService.clearAll.bind(this.dataTableSelectionService);
}
